import { ICellRendererFunc } from 'ag-grid-community';
import { StatusFieldOption } from 'api/tasks';
import { status } from 'components/organisms/projects/project-list/constants';
import { SingleSelectField } from 'components/organisms/tasks/fields';
import { getRenderer as getRendererBase } from 'components/organisms/tasks/renderers';
import { Field } from 'stores/fields';
import { ProjectFieldsName } from '../fields';
import {
  CsatRatingRenderer,
  getProjectStatusCellRendererFunc,
} from './cell-renderers';

export const getRenderer = (
  field: Pick<Field, 'type' | 'fieldName' | 'metaData' | 'sourceType'> & {
    fieldType?: string;
  },
): ICellRendererFunc | undefined | string => {
  if (field.fieldType === 'RATING') {
    return 'RatingRenderer';
  }
  switch (field.fieldName) {
    case ProjectFieldsName.projectName:
      return 'ProjectNameRenderer';
    case ProjectFieldsName.projectPhases:
      return 'ProjectPhasesCellRenderer';
    case ProjectFieldsName.progressPercent:
      return 'ProgressPercentCellRenderer';
    case ProjectFieldsName.projectHours:
      return 'ProjectHoursCellRenderer';
    case ProjectFieldsName.pastProjectStatus:
      return 'Last5StatusUpdatesCellRenderer';
    case ProjectFieldsName.status:
      return getProjectStatusCellRendererFunc(
        ((field as SingleSelectField).metaData
          .options as StatusFieldOption[]) ?? Object.values(status),
      );
    case ProjectFieldsName.estimatedDueDate:
      return 'EstimatedDueDateRenderer';
    case ProjectFieldsName.csatRating:
    case ProjectFieldsName.lastMilestoneCSAT:
      return CsatRatingRenderer;
    default:
      return getRendererBase(field);
  }
};
